import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import './WhyChooseUs.css'
import profit from '../../assets/images/why choose us/profit.png'
import quality from '../../assets/images/why choose us/quality.png'
import experience from '../../assets/images/why choose us/experience.png'
import incentive from '../../assets/images/why choose us/incentive.png'
import love from '../../assets/images/why choose us/love.png'
import theemmy from '../../assets/images/why choose us/theemmy.png'
import banner from '../../assets/images/why choose us banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const WhyChooseUs = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);
  return (
    <>
    <div className="container-fluid gx-0">
      <div className="row gx-0">
        <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
      </div>
    </div>

      <div className="container py-lg-5">
        <div className="row">
          <p className='px-5 top-content' data-aos="zoom-in">At Oreus Lifesciences, we understand that healthcare needs require a trusted partner. Here's why doctors, logistic partners, and patients choose us:</p>
        </div>
        <div className="row">
          <div className="col-4-lg col-md-4 col-sm-6">
            <div className="card why-choose-us-card py-lg-5 px-lg-3" data-aos="zoom-in">
              <div className="why-choose-us-icon">
              <img className='img-fluid' src={quality} alt="" />
              </div>
                <div className="why-choose-card-content">
                <h5>Quality and Reliability</h5>
                <p>- ISO 9001:2015 certification for quality management</p>
                <p>- Product purity and potency guarantee</p>
                <p>- Stringent quality control measures</p>
                </div>
            </div>
          </div>
          <div className="col-4-lg col-md-4 col-sm-6">
            <div className="card why-choose-us-card py-lg-5 px-lg-3" data-aos="zoom-in">
              <div className="why-choose-us-icon">
              <img className='img-fluid' src={experience} alt="" />
              </div>
                <div className="why-choose-card-content">
                <h5>Expertise and Experience</h5>
                <p>- Decades of industry experience</p>
                <p>- Team of seasoned pharmaceutical professionals</p>
                <p>- In-depth knowledge of regulatory affairs</p>
                </div>
            </div>
          </div>

          <div className="col-4-lg col-md-4 col-sm-6">
            <div className="card why-choose-us-card py-lg-5 px-lg-3" data-aos="zoom-in">
              <div className="why-choose-us-icon">
              <img className='img-fluid' src={profit} alt="" />
              </div>
                <div className="why-choose-card-content">
                <h5>Innovative Solutions</h5>
                <p>- Exclusive product portfolio with patented formulations</p>
                <p>- Research and development investments exceeding INR million</p>
                <p>- Partnerships with global innovators</p>
                </div>
            </div>
          </div>

          <div className="col-4-lg col-md-4 col-sm-6">
            <div className="card why-choose-us-card py-lg-5 px-lg-3" data-aos="zoom-in">
              <div className="why-choose-us-icon">
              <img className='img-fluid' src={incentive} alt="" />
              </div>
                <div className="why-choose-card-content">
                <h5>Business Benefits</h5>
                <p>- Competitive pricing and flexible payment terms</p>
                <p>- Efficient logistics and timely delivery</p>
                <p>- Dedicated customer support (24/7)</p>
                </div>
            </div>
          </div>

          <div className="col-4-lg col-md-4 col-sm-6">
            <div className="card why-choose-us-card py-lg-5 px-lg-3" data-aos="zoom-in">
              <div className="why-choose-us-icon">
              <img className='img-fluid' src={love} alt="" />
              </div>
                <div className="why-choose-card-content">
                <h5>Emotional Connection</h5>
                <p>- Patient-centric approach, prioritizing health outcomes</p>
                <p>- Compassionate patient support programs</p>
                <p>- Commitment to accessibility and affordability</p>
                </div>
            </div>
          </div>

        </div>
       
      </div>
     
      {/* Start Testimonials Section  */}
       <div className="container py-lg-5">
        <div className="row text-center pb-3 mt-5">
        <h1 className='main-heading' data-aos="zoom-in">Testimonials</h1>
        </div>
        <div className="row">
          <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className='testimonial-content' data-aos="zoom-in">
                <p>"Doctors across the globe have been our trusted partners for years. Our quality products and exceptional service have earned our loyalty."</p>
                </div>
              </div>
              <div className="carousel-item">
                <div className='testimonial-content'>
                <p >Our patient support programs have made a significant difference in patients' lives."</p>
                </div>
              </div>
            </div>
            <button className="carousel-control-prev " type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
              <span aria-hidden="true"><i className="bi bi-chevron-left"></i></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying " data-bs-slide="next">
              <span aria-hidden="true">
                <i className="bi bi-chevron-right"></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div> 
      {/* End Testimonials Section  */}
      
      <div className="container py-lg-5 py-3">
        <div className="row ">
          <div className="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
              <img  className='img-fluid' data-aos="zoom-in" src={theemmy} alt="" />
          </div>
          <div className="col-lg-6 col-md-6">
              <div className="awrd-content" data-aos="zoom-in">
                <h5>Awards and Recognition</h5>
                <p> Awarded and Recognized for "Excellence in Quality"</p>
                <h5 className='mt-lg-5'>Certifications and Compliance</h5>
                <p>- cGMP compliance</p>
                <p>- FDA and EU-GMP certified facilities</p>
                <p>- Compliance with international regulatory standards</p>
                <p>Join hands with us and experience the difference.</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  )
}

export default WhyChooseUs;
 